import {gets,getloginuser} from './userdefaultdata';

export const  getwebcode=()=>{
   let code ="OK";
   const ucode = gets('Username');
    if(ucode)
   code = ucode;
 return code;
};
export const  getwebpin=()=>{
   
  let pin =1;
  const upin = gets('Userpin');
  
  if(upin)
  pin = parseInt(upin);
 return pin;
};


export const  chkwbauthu=()=>{
   let isvalid = false;
   const suid = gets('Superuserid');
   if(suid != 'NA'){
     const cod = getwebcode();
     const pin = getwebpin();
     if(cod !="OK" && pin > 999 ) isvalid = true;
   }
 return isvalid;
};

export const  connectweb=()=>{
   const susrid = gets('Superuserid');
   const usercode = getwebcode();
   const userpin = getwebpin();

   const userinfo = usercode + '-' + susrid + '-' + userpin;
   //alert(userinfo);
   getloginuser(userinfo);
};